/* eslint-disable no-useless-escape */
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { markdownParser } from 'prose-core'
import { SuggestionRequestWithRequester } from 'types'

export const totalCopyOptions = (channel: ChannelType, request: SuggestionRequestWithRequester) => {
  switch (channel) {
    case ChannelType.Tweets:
      return request.prompt.count - 1
    case ChannelType.LinkedInPosts:
      if (request.prompt.post_length === 'Medium (50-150 words)') return 5
      if (request.prompt.post_length === 'Long (150+ words)') return 3

      return 10
    case ChannelType.InstagramPosts:
      if (request.prompt.post_length === 'Medium (30-100 words)') return 5
      if (request.prompt.post_length === 'Long (100+ words)') return 3

      return 10
    case ChannelType.FacebookPost:
      if (request.prompt.post_length === 'Medium (50-150 words)') return 5
      if (request.prompt.post_length === 'Long (150+ words)') return 3

      return 10
    default:
      return 5
  }
}

export const altCopyOptions = (content: string, channel: ChannelType) => {
  switch (channel) {
    case ChannelType.Tweets:
      const tweets_sections = content.split(/^# .*/)
      const tweets_section = tweets_sections.find((section) => section.trim().match(/^(\d+\.|-|\*)\s/))
      const tweet_copies = tweets_section?.match(/^(\d+\.|\s*[-+*]) (.*?)(?=\n|\z)/gm)

      return tweet_copies?.length
    case ChannelType.LinkedInPosts:
      const posts = content.match(/^###\#*.*?\n([\s\S]+?)(?=\n###\#*\s|\n##\s|\z)/gm)

      return posts?.length
    case ChannelType.InstagramPosts:
      const instagram_sections = content.split(/^## .*/)
      const instagram_captions = instagram_sections[0]?.match(/^(\d+\.|\s*[-+*]) (.*?)(?=\n|\z)/gm)

      return instagram_captions?.length
    case ChannelType.FacebookPost:
      const postIdeas = content.match(/Post Idea \d/gm)

      return postIdeas?.length
    default:
      return 0
  }
}

export const extractFirstCopy = (streamContent: string, channel: ChannelType) => {
  const markdownContent = markdownParser.parse(streamContent)?.toJSON().content || []

  switch (channel) {
    case ChannelType.Tweets:
      const tweets = markdownContent.find((c: { type: string }) => c.type === 'ordered_list')
      const firstTweet = tweets?.content?.slice(0, 1)

      return firstTweet
    case ChannelType.InstagramPosts:
      const captions = markdownContent.find((c: { type: string }) => c.type === 'ordered_list')
      const firstCaption = captions?.content?.slice(0, 1)

      return firstCaption
    case ChannelType.LinkedInPosts:
    case ChannelType.FacebookPost:
      const firstPreviewCopyParagraphIndex = markdownContent.findIndex(
        (c: { type: string }) => c.type === 'paragraph' || c.type === 'ordered_list',
      )
      const lastPreviewCopyParagraphIndex = markdownContent.findIndex(
        (c: { type: string }, index: number) =>
          (c.type === 'paragraph' || c.type === 'ordered_list' || c.type === 'unordered_list') &&
          (markdownContent[index + 1]?.type === 'heading' || markdownContent[index + 1] === undefined),
      )

      return markdownContent?.slice(firstPreviewCopyParagraphIndex, lastPreviewCopyParagraphIndex + 1)
    default:
      return ''
  }
}
